/* eslint-disable import/prefer-default-export */
export const getTeams = (state, ids) => (ids.map((id) => state.teams[id]));
export const getTeam = (state, id) => state.teams[id];
